export const handleInputPercentage = (event) => {
  let value = event.target.value;
  value = value.replace(/[^0-9]/g, "");

  const numericValue = parseFloat(value);

  if (numericValue > 100) {
    value = value.slice(0, -1);
  }

  if (/^0[0-9]+$/.test(value)) {
    value = "0";
  }

  event.target.value = value;
};

export const setErrorPercentage = (setError, getValues) => {
  getValues("beneficiaries").forEach((_, index) => {
    setTimeout(() => {
      setError(`beneficiaries.${index}.percentage`, {
        type: "invalidExceeded",
        message: "Porcentaje excedido",
      });
    }, 100);
  });
};
